<!--
  - Copyright (c) 2019 LNBIG.com
  - All rights reserved.
  -->

<template>
  <div>
    <v-card class="mx-auto">
      <v-card flat>
        <v-card-title>Purchase an inbound channel from LNBIG</v-card-title>
        <v-container class="fill-height" fluid>
          <template v-if="minChannelVolume && maxChannelVolume">
            <v-row>
              <v-col cols="12">
                <v-slider
                  class="mx-3"
                  :max="maxChannelVolume"
                  :min="minChannelVolume"
                  v-model="requestSats"
                ></v-slider>
              </v-col>
              <v-col cols="12">
                <v-list two-line style="background: transparent !important">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-gas-station</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                        >{{ numberWithCommas(requestSats) }}
                      </v-list-item-title>
                      <v-list-item-subtitle>Volume, sats</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon :style="`transform: rotate(14deg)`"
                        >$satoshi</v-icon
                      >
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-currency-usd</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                        >${{ priceForChannelUsd }}</v-list-item-title
                      >
                      <v-list-item-subtitle>Price, USD</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon>mdi-currency-usd</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-currency-usd-off</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                        >{{ numberWithCommas(priceForChannelSats) }}
                      </v-list-item-title>
                      <v-list-item-subtitle>Price, sats</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon :style="`transform: rotate(14deg)`"
                        >$satoshi</v-icon
                      >
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-cash-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                        >${{ channelVolumeInUsd }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >Can get up to, USD</v-list-item-subtitle
                      >
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon :style="`transform: rotate(14deg)`"
                        >$satoshi</v-icon
                      >
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-ticket-confirmation-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{
                          Math.round(
                            (limitsAndPrices.satPerKwEconomy * 4) / 1000
                          )
                        }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >Opening fee, sat/vB</v-list-item-subtitle
                      >
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon>mdi-speedometer-slow</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-exit-run</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{
                          Math.round(
                            (limitsAndPrices.satPerKwConservative * 4) / 1000
                          )
                        }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >Closing fee, sat/vB</v-list-item-subtitle
                      >
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon>mdi-speedometer</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-col>
              <!--              <v-col cols="12">
                <v-card class="mx-auto text-left" tile color="deep-orange" dark>
                  <v-card-title>
                    Opening the channel, you agree with the following
                    terms:
                  </v-card-title>
                  <v-list color="deep-orange lighten-1" light>
                    <v-list-item v-for="(item, i) in terms" :key="i">
                      <v-list-item-content>
                        <v-list-item-title
                          class="white&#45;&#45;text"
                          v-text="item.title"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          class="deep-orange&#45;&#45;text text&#45;&#45;lighten-5"
                          v-text="item.text"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>-->
              <v-col cols="12">
                <v-card class="mx-auto text-left" tile>
                  <v-card-title>
                    You agree with the following terms:
                  </v-card-title>
                  <v-list>
                    <v-list-item v-for="(item, i) in terms" :key="i">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.title"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="item.text"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-card-actions>
                    <v-btn
                      @click="startOpenChannelProcess(requestSats)"
                      :disabled="Boolean(prepayment.invoice || openChannelInfo.lnurl)"
                      color="primary"
                      class="ml-1 mb-3"
                    >
                      I agree
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <v-alert v-else-if="limitsAndPricesError" type="error">{{
            limitsAndPricesError
          }}</v-alert>
          <v-alert v-else-if="webSocketError" type="error">{{
            webSocketError
          }}</v-alert>
          <template v-else>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="card-heading, sentences, divider, text, button"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </template>
        </v-container>
        <!--      <v-img
                :src="require('../assets/lightning-1.svg')"
              >

              </v-img>-->
      </v-card>
    </v-card>
    <connect-method
      v-if="!recaptchaV2.show"
      :active="true"
      class="mx-0 px-0"
    ></connect-method>
    <div v-else>
      <vue-recaptcha
        :load-recaptcha-script="true"
        :sitekey="recaptchaV2SiteKey"
        @expired="onExpiredRecaptchaV2"
        @verify="onVerifyRecaptchaV2"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import dbg from "debug";
import numberWithCommas from "../numberWithCommas";
import ConnectMethod from "@/components/ConnectMethod";

const debug = dbg("lnbig:open-channel-wizard");

export default {
  components: {
    ConnectMethod,
  },
  props: {
    uuid: null,
  },
  data() {
    return {
      requestSatsData: null,
      recaptchaV2: {
        show: false,
        resolve: null,
        reject: null,
      },
      recaptchaV2SiteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_V2_SITE_KEY,
      terms: [
        {
          title: "One month minimum",
          text: "There are no guarantees that the channel will remain a long time, but we will try to keep it open at least a month.",
        },
        {
          title: "Use the channel!",
          text: "Channels that are innactive for 30 days will be seen as useless and can lead to closure.",
        },
        {
          title: "No guarantees!",
          text: "But cannot make any guarantees. Lightning is reckless.",
        },
        {
          title: "First channel, then satoshis!",
          text: "You only pay after the successful opening of the channel - creating a funding transaction. Once the channel opening tx is initiated, the HODL invoice will complete.",
        },
        {
          title: "What is the price of channel",
          text: "Put simply, the price covers the transaction of the opening of the channel, its future force closure and the price for renting funds.",
        },
        {
          title: "Share sessions! Someone pays, and someone opens!",
          text: "Starting from the next step, you can share the address of the session with anyone and act together - someone pays, and someone opens.",
        },
      ],
      /*
       smoothLimitsAndPricesTransition: true,
       */
    };
  },
  computed: {
    ...mapState("openChannel", [
      "prepayment",
      "openChannelInfo",
      "limitsAndPrices",
      "limitsAndPricesLoading",
      "limitsAndPricesError",
    ]),
    ...mapState(["webSocketError"]),
    openChannelTab: {
      get: function () {
        debug("openChannelTab/get");
        return this.openChannelInfo.openingMethod === "lnurl" ? 0 : 1;
      },
      set: function (val) {
        debug("openChannelTab/set");
        this.connectMethodCommand({
          command: "changeOpeningMethod",
          payload: val === 0 ? "lnurl" : "connect",
        });
      },
    },
    step() {
      if (!this.prepayment.prepaid && !this.prepayment.invoice) return 1;
      if (!this.prepayment.prepaid && this.prepayment.invoice) return 2;
      if (
        (this.prepayment.prepaid && !this.openChannelInfo.opened) ||
        this.openChannelTab === 1
      )
        return 3;
      if (
        this.prepayment.prepaid &&
        this.openChannelInfo.opened &&
        this.openChannelTab === 0
      )
        return 4;
      return 1;
    },
    minChannelVolume() {
      return this.limitsAndPrices && this.limitsAndPrices.min.channelVolume;
    },
    maxChannelVolume() {
      return this.limitsAndPrices && this.limitsAndPrices.max.channelVolume;
    },
    requestSats: {
      get() {
        if (this.requestSatsData) return this.requestSatsData;
        return this.minChannelVolume;
      },
      set(value) {
        if (!this.limitsAndPrices)
          throw new Error("set of requestSats: no limits defined");
        if (
          value >= this.limitsAndPrices.min.channelVolume &&
          value <= this.limitsAndPrices.max.channelVolume
        )
          this.requestSatsData = value;
        else throw new Error("set of requestSats: outside value");
      },
    },
    priceForChannelSats() {
      if (!this.limitsAndPrices) return null;
      return Math.round(
        ((this.limitsAndPrices.max.priceSats -
          this.limitsAndPrices.min.priceSats) *
          (this.requestSats - this.limitsAndPrices.min.channelVolume)) /
          (this.limitsAndPrices.max.channelVolume -
            this.limitsAndPrices.min.channelVolume) +
          this.limitsAndPrices.min.priceSats +
          (this.limitsAndPrices.priceForVolumePpm
            ? (this.requestSats / 1e6) * this.limitsAndPrices.priceForVolumePpm
            : 0)
      );
    },

    /**
     * Returns the price in USD as string like '$D.CC'
     * @returns {string}
     */
    priceForChannelUsd() {
      let cents = Math.round(
        this.priceForChannelSats / this.limitsAndPrices.centRate
      );
      return String(Math.floor(cents / 100)) + "." + String(cents % 100);
    },
    channelVolumeInUsd() {
      let cents = Math.round(
        (this.requestSats * 0.99) / this.limitsAndPrices.centRate
      );
      return String(Math.floor(cents / 100)) + "." + String(cents % 100);
    },
  },
  watch: {
    "prepayment.oc_uuid": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        debug("oc_uuid был изменён в state - толкаем соответствующий маршрут");
        // TODO сделать потом здесь счётчик защиты от бесконечных редиректов (иногда бывает)
        if (newVal)
          this.$router
            .push({ path: this.$route.path, query: { oc_uuid: newVal } })
            .catch((err) => {});
        else this.$router.push({ path: this.$route.path }).catch((err) => {});
      }
    },
    uuid: async function (newVal, oldVal) {
      debug("watch uuid: changed, newVal=%s, oldVal=%s", newVal, oldVal);
      if (newVal !== oldVal) await this.setCurrentUuid(newVal);
    },
    /*
     limitsAndPricesLoading(newVal) {
     if (newVal) {
     this.smoothLimitsAndPricesTransition = false
     setTimeout(() => {this.smoothLimitsAndPricesTransition = true}, 2000)
     }
     },
     */
  },
  mounted: async function () {
    try {
      debug("mounted started");
      this.resetReCaptchaV2();
      this.resetReCaptchaV3();
      await this.checkHelloAndRecaptcha(this);
      await this.setCurrentUuid(this.uuid);
    } catch (e) {
      console.log("mounted(): %s", e.message);
    }
  },
  methods: {
    ...mapMutations("openChannel", [
      "resetReCaptchaV2",
      "resetReCaptchaV3",
      "cmdSetPrepayment",
    ]),
    ...mapActions("openChannel", [
      "checkHelloAndRecaptcha",
      "startOpenChannelProcess",
      "linkOpenChannelProcess",
      "getLimitsAndPrices",
      "restartOpenChannel",
      "connectMethodCommand",
    ]),

    // Запускает recaptchaV2 и возвращает token
    getTokenRecaptchaV2() {
      this.recaptchaV2.show = true;
      return new Promise((resolve, reject) => {
        this.recaptchaV2.resolve = resolve;
        this.recaptchaV2.reject = reject;
      });
    },

    onVerifyRecaptchaV2(response) {
      debug("onVerifyRecaptchaV2, res=%o", response);
      this.recaptchaV2.resolve(response);
      this.recaptchaV2.show = false;
    },

    onExpiredRecaptchaV2() {
      debug("onExpiredRecaptchaV2");
      this.recaptchaV2.reject("The recaptcha was expired");
    },

    numberWithCommas,

    async setCurrentUuid(uuid) {
      if (uuid) {
        debug(
          "setCurrentUuid, uuid=%s, startedFromHere=%o, startedUuid=%s",
          uuid,
          this.prepayment.startedFromHere,
          this.prepayment.startedUuid
        );
        if (
          this.prepayment.startedFromHere !== true ||
          (this.prepayment.startedUuid && this.prepayment.startedUuid !== uuid)
        )
          await this.linkOpenChannelProcess(uuid)
      } else {
        await this.getLimitsAndPrices()
      }
    },
  },
};
</script>
